import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { Sparkles } from 'lucide-react';

const VisionSection = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  
  return (
    <section 
      id="vision" 
      ref={ref}
      className="section-spacing relative bg-[#F8FAFC] overflow-hidden"
      data-testid="vision-section"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#2563EB]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[#60A5FA]/5 rounded-full blur-3xl" />
      
      <div className="section-container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center"
        >
          {/* Icon */}
          <div className="w-20 h-20 mx-auto mb-8 rounded-3xl bg-[#2563EB]/10 flex items-center justify-center">
            <Sparkles className="w-10 h-10 text-[#2563EB]" />
          </div>
          
          {/* Title */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-8">
            <span className="gradient-text">{t.vision.title}</span>
          </h2>
          
          {/* Description */}
          <p className="text-xl text-[#475569] leading-relaxed max-w-3xl mx-auto">
            {t.vision.description}
          </p>
          
          {/* Decorative Elements */}
          <div className="mt-16 flex justify-center gap-8">
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={isInView ? { opacity: 1, scale: 1 } : {}}
              transition={{ delay: 0.3 }}
              className="w-2 h-2 rounded-full bg-[#2563EB]"
            />
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={isInView ? { opacity: 1, scale: 1 } : {}}
              transition={{ delay: 0.4 }}
              className="w-2 h-2 rounded-full bg-[#60A5FA]"
            />
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={isInView ? { opacity: 1, scale: 1 } : {}}
              transition={{ delay: 0.5 }}
              className="w-2 h-2 rounded-full bg-cyan-400"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VisionSection;
